<ng-container *ngIf="loaded; then usrCreated; else usrCreation"></ng-container>

<ng-template #usrCreation>
  <form [formGroup]="registrationFormGroup" (submit)="onSubmitButtonClick()" class="registration-form">
    <ion-list class="list">
      <ion-item lines="none">
        <ion-button slot="start"
          (click)="onCloseButtonClick()"
          color="light"
          shape="round"
          class="modal-up-button">
          <i class="far fa-times-circle icon edge-cancel"></i>
          <span>Cancel</span>
        </ion-button>

        <ion-text class="registration-header">First Time User</ion-text>

        <ion-button slot="end"
          type="submit"
          [disabled]="!registrationFormGroup.valid || disableBtns"
          shape="round"
          class="modal-up-button">
          <i class="fas fa-envelope icon edge-submit"></i>
          <span>Submit</span>
        </ion-button>
      </ion-item>
    </ion-list>

    <ion-content>
      <ion-list [formGroup]="accountFormGroup">
        <ion-item lines="none">
          <ion-text class="text-wrap">
            <p>
              <strong>Sony Music Promo Portal</strong>
            </p>
            <p class="ion-text-justify">
              If you are a first time user, please fill out the form below using the email address where you receive Sony Music
              Promo E-cards. To register with a new email address, you will need to contact your Sony Rep to have your email address added
              to their contact list and to request a Promo E-card delivery. Once you have received a Promo E-card delivery from Sony Music, your
              email address will be cleared for registration.
            </p>
            <p class="ion-text-justify">
              Please read the Sony Music
              <span (click)="openTerms()" class="link">Terms
                and Conditions</span> and
              <span (click)="openPrivacy()" class="link">Privacy Policy</span>
              before creating an account and using this application.
            </p>
          </ion-text>
        </ion-item>

        <ion-item [ngClass]="{'valid': accountFormGroup.get('firstName').valid}">
          <ion-label position="stacked">
            First Name<span class="required">*</span>
          </ion-label>
          <ion-input formControlName="firstName"
            type="text"
            name="firstName"
            [placeholder]="'Enter First Name'"
            class="input">
          </ion-input>
        </ion-item>

        <div class="rules">
          <strong>First Name rules:</strong>
          <ul>
            <li *ngFor="let rule of validationMessages.firstName"
              [ngClass]="getValidClass('firstName', rule.type)">
              {{rule.message}}
            </li>
          </ul>
        </div>

        <ion-item [ngClass]="{'valid': accountFormGroup.get('lastName').valid}">
          <ion-label position="stacked">
            Last Name<span class="required">*</span>
          </ion-label>
          <ion-input formControlName="lastName"
            type="text"
            name="lastName"
            [placeholder]="'Last Name'"
            class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>Last Name rules:</strong>
          <ul>
            <li *ngFor="let rule of validationMessages.lastName"
              [ngClass]="getValidClass('lastName', rule.type)">
              {{rule.message}}
            </li>
          </ul>
        </div>

        <ion-item [ngClass]="{'valid': accountFormGroup.get('emailAddress').valid}">
          <ion-label position="stacked">
            Email<span class="required">*</span>
          </ion-label>
          <ion-input formControlName="emailAddress"
            name="email"
            [placeholder]="'Enter Email Address'"
            class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>Email rules:</strong>
          <ul>
            <li *ngFor="let rule of validationMessages.emailAddress"
              [ngClass]="getValidClass('emailAddress', rule.type)">
              {{rule.message}}
            </li>
          </ul>
        </div>

        <ion-item class="do-not-validate">
          <ion-label position="stacked">
            Company<span class="required">*</span>
          </ion-label>
          <ion-input formControlName="companyName"
            type="text"
            [placeholder]="'Enter Company Name'"
            class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>Company Name rules:</strong>
          <ul>
            <li *ngFor="let rule of validationMessages.companyName"
                [ngClass]="getValidClass('companyName', rule.type)">
              {{rule.message}}
            </li>
          </ul>
        </div>

        <ion-item [ngClass]="{'valid': accountFormGroup.get('password').valid}">
          <ion-label position="stacked">
            Password<span class="required">*</span>
          </ion-label>
          <div class="input-container">
            <ion-input formControlName="password"
              type="{{typePass}}"
              name="password"
              clearOnEdit="false"
              [placeholder]="'Password'"
              class="input">
            </ion-input>
            <button *ngIf="!showPass"
              type="button"
              ion-button clear
              (click)="showPassword()"
              class="button">
              <i class="fas fa-eye-slash icon invert-icon"></i>
            </button>
            <button *ngIf="showPass"
              type="button"
              ion-button clear
              (click)="showPassword()"
              class="button">
              <i class="fas fa-eye icon invert-icon"></i>
            </button>
          </div>
        </ion-item>
        <div class="rules">
          <strong>Required:</strong>
          <ul>
            <ng-container *ngFor="let rule of validationMessages.password">
              <li [ngClass]="getValidClass('password', rule.type)">
                {{rule.message}}
              </li>
            </ng-container>
          </ul>
        </div>

        <ion-item [ngClass]="getValidClass('rePassword', 'passwordCompare')">
          <ion-label position="stacked">
            Confirm Password<span class="required">*</span>
          </ion-label>
          <div class="input-container">
            <ion-input formControlName="rePassword"
              type="{{typeRePass}}"
              name="rePassword"
              clearOnEdit="false"
              [placeholder]="'Re-Enter Password'"
              class="input">
            </ion-input>
            <button *ngIf="!showRePass"
              type="button"
              ion-button clear
              (click)="showRePassword()"
              class="button">
              <i class="fas fa-eye-slash icon invert-icon"></i>
            </button>
            <button *ngIf="showRePass"
              type="button"
              ion-button clear
              (click)="showRePassword()"
              class="button">
              <i class="fas fa-eye icon invert-icon"></i>
            </button>
          </div>
        </ion-item>
        <div class="rules">
          <strong>Required:</strong>
          <ul>
            <li [ngClass]="getValidClass('rePassword', 'passwordCompare')">
              Must re-type password to ensure correctness
            </li>
          </ul>
        </div>

        <ion-item class="last-item do-not-validate">
          <ion-label position="stacked">
            Your Sony Music Promo Rep
          </ion-label>
          <ion-input formControlName="referredByRep"
            type="text"
            name="referredByRep"
            [placeholder]="'Enter Rep Full Name'"
            class="input">
          </ion-input>
        </ion-item>

        <ion-item lines="none">
          <ion-text class="text-wrap">
            <p class="ion-text-justify">
              <input class="first-time-user-input" type="checkbox" formControlName="cbTerms" />
              I have read and understood the Sony Music
              <span (click)="openTerms()" class="link">Terms
              and Conditions</span> and
              <span (click)="openPrivacy()" class="link">Privacy Policy</span>
              and agree to these terms and I agree to the processing of my data in accordance with the Privacy Policy.
            </p>
          </ion-text>
        </ion-item>

      </ion-list>
    </ion-content>
  </form>

</ng-template>

<ng-template #usrCreated>
  <div class="confirmation">
    <ion-list>
      <ion-item lines="none">
        <ion-button slot="start" (click)="onCloseButtonClick()"
                    color="light"
                    shape="round"
                    class="modal-up-button">
          <i class="far fa-times-circle icon"></i>
          <span>Close</span>
        </ion-button>
        <ion-text class="registration-header">First Time User</ion-text>
      </ion-item>
    </ion-list>

    <ion-list>
      <ion-item lines="none">
        <strong>Submitted!</strong>
      </ion-item>
      <ion-item lines="none">
        Thank you for signing up. You will receive an email for verification.
      </ion-item>
    </ion-list>
  </div>
</ng-template>
